import { getLogger } from '@ragu-components/logger';

export const flowchartLogger = getLogger('flowchart');
export const analyticsLogger = getLogger('analytics');
